<!-- Toolbar -->
<mat-toolbar color="primary">
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
    <h1>Financial Distress Calculator</h1>
  </mat-toolbar-row>
</mat-toolbar>

<div class="content" role="main">
  <app-calculator></app-calculator>
</div>